import React, { useEffect, useState } from 'react'
import {
	CRow, CCard,
	CCol, CButton,
} from 'compat/coreui';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../components/css/Cart.css';

export default function Cart(props) {

	const [cartData, setCartData] = useState([]);
	const [quantity, setQuantity] = useState("0");
	const [totalAmount, setTotalAmount] = useState(0)

	const mytoken = localStorage.getItem('token');
	const orderDetails = localStorage.getItem('myProduct');

	useEffect(() => {
		if (orderDetails) {
			setCartData(JSON.parse(orderDetails))
			calculatTotal(JSON.parse(orderDetails))
		}
	}, [])
	const calculatTotal = (e) => {
		let sum = 0;
		for (let index = 0; index < e.length; index++) {
			let item = e[index];
			let thisPrice = 0;
			if (item.priceType === "priceHalf") {
				thisPrice = item.productDetails.priceHalf;
			} else if (item.priceType === "priceEight") {
				thisPrice = item.productDetails.priceEight
			} else if (item.priceType === "priceForth") {
				thisPrice = item.productDetails.priceForth
			} else if (item.priceType === "priceOz") {
				thisPrice = item.productDetails.priceOz
			} else {
				thisPrice = item.productDetails.price
			}
			console.log("thi price ", thisPrice);
			sum = parseFloat(thisPrice) + parseFloat(sum);
		}
		console.log("====> sum set ", sum);
		setTotalAmount(sum);
	}
	const placeOrder = (e) => {
		e.preventDefault();
		let cdata = cartData.slice().map(product => {
			product.productDetails = undefined
			return product
		});

		axios({
			url: `${process.env.REACT_APP_APP_API_URL}/api/order`,
			method: 'POST',
			headers: {
				'Authorization': 'Bearer ' + mytoken
			},
			data: {
				products: cdata
			}
		}).then(response => {
			if (response.data.status) {
				localStorage.removeItem('myProduct');
				setCartData([]);
				toast.success('Ordered successfully');
			}
		}).catch(console.log)
	}

	const removeItem = (id) => {
		let arr = [...cartData];
		arr.splice(id, 1);
		setCartData(arr);
		if (cartData.length = 0) {
			localStorage.removeItem('myproduct');
		} else {
			const newData = JSON.stringify(cartData)
			localStorage.setItem('myProduct', newData);
		}
		calculatTotal(cartData)
	}
	const goBack = () => {
		window.history.back();
	}
	const increment = (index) => {
		let element = cartData[index];
		element.quantity = parseInt(element.quantity)+1;
		cartData[index] = element;
		setCartData(cartData)
		console.log(cartData);
	}


	return (
		<div className="pt-5 container">
			{cartData.length > 0 ?
				<CRow className="mt-5 mb-5">
					<CCol lg={12} sm={12} className="m-auto">
						<CCard className="cart-page pt-5 pb-5">
							<div className="col-sm-8 text-left pb-5">
								<h2 style={{ color: 'green' }}>Shopping Cart</h2>
							</div>
							<div><span className="btn btn-update">Update cart</span></div>
							<CCol lg={9}>
								<div className="table-responsive cart-table">
									<table style={{ width: '100%' }}>
										<thead>
											<tr>
												<th>Product</th>
												<th>Description </th>
												<th>Price </th>
												<th> QTY </th>
												<th> Total </th>
												<th> Action </th>
											</tr>
										</thead>
										<tbody>
											{(cartData.length > 0) && cartData.map((item, index) => {
												return (<tr key={index}>
													<td>
														{item.productDetails.image !== null ? <img src={item.productDetails.image} alt="kitten" width="35" /> : <img src="/images/w.png" alt="kitten" width="20" />}
														<span style={{ width: '150px', color: 'green' }}>{item.productDetails !== undefined ? item.productDetails.name : ""}</span>
														{/*<span onClick={() => removeItem(index)}><i className="fa fa-times-circle"></i></span>*/}
													</td>
													<td>
													{item.productDetails.description}
													</td>
													<td>
														<span className="price-type">
															${item.priceType === "priceHalf" ? item.productDetails.priceHalf
															: item.priceType === "priceEight" ? item.productDetails.priceEight
															: item.priceType === "priceForth" ? item.productDetails.priceForth
															: item.priceType === "priceOz" ? item.productDetails.priceOz
															: item.productDetails.price
															}
														</span>
													</td>

													<td><span className="price-type"><span type="numeric" style={{ width: 'inherit', textAlign: "center", fontSize: "20px" }} >{item.quantity}</span></span></td>
													<td>{item.quantity * parseFloat(item.priceType === "priceHalf" ? item.productDetails.priceHalf
														: item.priceType === "priceEight" ? item.productDetails.priceEight
														: item.priceType === "priceForth" ? item.productDetails.priceForth
														: item.priceType === "priceOz" ? item.productDetails.priceOz
														: item.productDetails.price)}</td>
													<td><span onClick={() => removeItem(index)}><i className="fa fa-times-circle"></i></span></td>
												</tr>)
											}
											)}
										</tbody>
										<thead>
											<tr>
												<th> </th>
												<th>  </th>
												<th> Total </th>
												<th> {totalAmount} </th>
												<th> <a href="#" className="btn btn-success" onClick={placeOrder}>Checkout <i className="fa fa-angle-right" /></a> </th>
											</tr>
										</thead>
									</table>
								</div>

								{/*<a href="#" className="btn btn-success" className="mt-5" onClick={placeOrder}>Checkout <i className="fa fa-angle-right" /></a>*/}

								{/* <a href="#" className="btn btn-success">Checkout <i className="fa fa-angle-right" /></a> */}
								{/*<CButton color="success" className="mt-5" onClick={placeOrder}>PLACE ORDER</CButton>
								<CButton color="success" className="mt-5" style={{ marginLeft: "10px" }} onClick={goBack} >Add More</CButton>*/}
							</CCol>
						</CCard>
					</CCol>

				</CRow> :

				<CRow className="mt-5">
					<CCol lg={8} className="empty_cart_message">
						<CCard className="text-center">
							<span><img src="/images/emptycart.png" width="150px" /></span>
							<h2>Your cart is empty</h2>
						</CCard>
					</CCol>
				</CRow>
			}
		</div>

	)
}
